<template>
  <CustomDialog
    :visible="visible"
    @update:visible="updateVisible"
    modalClass="w-[936px]"
    :closable="closable"
  >
    <template #header>
      <div class="inline-flex items-center justify-center gap-2">
        <span
          class="ml-2 font-600 whitespace-nowrap text-[20px] leading-24 tracking-[-0.2px] dark:text-text-primary-dark"
        >
          Multicuenta
        </span>
      </div>
    </template>
    <!-- Descripción -->
    <template #description>
      <MainTable
        :items="items"
        :columns="columns"
        :requiredArrow="false"
      ></MainTable>
    </template>
    <!-- Botones -->
    <template #footer> </template>
  </CustomDialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import CustomDialog from "./CustomDialog.vue";

const props = defineProps({
  items: Object,
  visible: Boolean,
  closable: Boolean,
});
const emit = defineEmits(["update:visible"]);

const columns = ref([
  { field: "bankName", header: "cuenta" },
  { field: "accountType", header: "Tipo de cuenta" },
  { field: "accountNumber", header: "Numero de cuenta" },
  { field: "moneyType", header: "Moneda" },
  { field: "alias", header: "Alias" },
]);

const updateVisible = (value: boolean) => {
  emit("update:visible", value);
};
</script>
